<template>
    <div class="main">
        <div>
            <router-link to="/view-orders" style="font-size:14px;width:30%;text-decoration: none;line-height:30px;color:#98c14b;display:flex">
                <p>
                    <a-icon type="double-left" />
                </p> 
                <p>Go Back To View Order</p>
                
            </router-link>
    
            <h3 style="font-size:28px;line-height:45px">Back Order Campaign</h3>
            
            <div>
                <!-- <div style="background:#fbfbfb;padding: 10px;box-shadow: rgb(136 136 136 / 42%) 0px 2px 8px">
                    <a-row>
                        <a-col style="border-right: dotted;height: 150px;padding: 20px;" :span="9">
                            <a-col>
                                <div style="display:flex;justify-content: center;">
                                    <img class="img_size" src="../../assets/img/inventory_1.png"/>
                                </div>
                            </a-col>
                            <a-col style="text-align:center;padding-top:10px">
                                {{showCampaignDate.startDate}}  -  {{showCampaignDate.endDate}}  <span style="color:green">({{showCampaignDate.numberOfDays}})</span>
                            </a-col>
                            <a-col style="text-align:center;padding-top:10px">
                                StartDate - EndDate
                            </a-col>

                        </a-col>
                        <a-col style="border-right: dotted;height: 150px;padding: 20px;text-align:center" :span="7">
                            
                                <img class="img_size" src="../../assets/img/filledoutline.png"/>
                                <div style="padding-top:20px; text-align: -webkit-center;">
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #fff2d6;width: 118px;height: 27px;border-radius: 30px" v-if="items.statusLabel === 'Pending'">
                                        
                                        <p style="font-size:12px;color:#ffb102;"> {{items.statusLabel}} </p>
                                    </div>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: rgb(112 236 110 / 55%);width: 118px;height: 27px;border-radius: 30px" v-if="items.statusLabel === 'Live'">
                                        
                                        <p style="font-size:12px;color:rgb(23 140 20);"> {{items.statusLabel}} </p>
                                    </div>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #d1edfc;width: 118px;height: 27px;border-radius: 30px" v-if="items.statusLabel === `Completed`">
                                  
                                        <p style="font-size:12px;color:#41c4fd;"> {{items.statusLabel}} </p>
                                    </div>
                                </div>
                        </a-col>
                        
                    </a-row>
                </div> -->

                <div style="padding-top:30px;padding-bottom:30px">
                    <div style="display:flex;justify-content: space-between;margin-bottom">
                        <!-- <p>Breakdown:</p> -->
                        <div style="font-size:18px">
                            <p>Waybills</p>
                        </div>

                        <!-- <a-button icon="filter" style="margin-top: -5px;">
                        Filter
                        </a-button> -->
                        <div style="display: flex;justify-content: flex-end">
                            <a-button  @click="showViewCampaign" style="height:38px; border-raduis:5px;margin-right:10px; background: #418a49; color:#fff;" icon="notification">
                                View Campaign
                            </a-button>
                            <a-button @click="exportExcell" style="height:38px; border-raduis:5px;margin-right:10px; background: #418a49; color:#fff;" icon="export">
                                Export
                            </a-button>
                            <a-dropdown>
                            <a-menu slot="overlay">
                                    <a-menu-item @click="showAggregateOrder" key="2">Aggregate Orders</a-menu-item>
                                    <a-menu-item @click="showPurchaseOrder" key="3"> Purchased Order </a-menu-item>
                                </a-menu>
                                <a-button style="height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;" icon="select">
                                Actions <a-icon type="down" />
                            </a-button>
                            </a-dropdown>
                        </div>
                    </div>
                    <a-table
                    :columns="columns"
                    :data-source="tableData"
                    :pagination="pagination"
                    @change="handleTableChange"
                    :loading="tableLoading"
                    class="productTable"
                    >
            
                            <span slot="action" slot-scope="data">
                                    <!-- <router-link style="color:#98c14b;" to="/order-details"><a-icon style="font-size:25px;" type="ellipsis" /> </router-link> -->
                                    <!-- <a @click="showMoreDetails(data)" style="color:#98c14b;"><a-icon style="font-size:25px;" type="ellipsis" /> </a> -->
                                    <a-dropdown>
                                        <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                            <a-icon style="font-size:25px;" type="ellipsis" />
                                        </a>
                                        <a-menu slot="overlay">
                                            <a-menu-item @click="showWaybillModal(data)">
                                                <a>View Waybill Details</a>
                                            </a-menu-item>
                                            <!-- <a-menu-item>
                                                <a>Email</a>
                                            </a-menu-item>
                                            <a-menu-item>
                                                <a>Download</a>
                                            </a-menu-item> -->
                                            
                
                                        </a-menu>
                                    </a-dropdown>
                            </span>
                            <template slot="status" slot-scope='data'>
                                <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #fff2d6;width: 118px;height: 27px;border-radius: 30px" v-if="data === 'Pending'">
                                    <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
                                    <p style="font-size:12px;color:#ffb102;"> Pending </p>
                                </div>
                                <div style="display: flex;padding-top: 4px;justify-content: space-around;background: rgb(112 236 110 / 55%);width: 118px;height: 27px;border-radius: 30px" v-if="data === 'Active'">
                                    <!-- <p style="width: 9px;height: 9px;background: #134e12;margin-top: 5px;border-radius:50%"></p> -->
                                    <p style="font-size:12px;color:rgb(23 140 20);"> Active </p>
                                </div>
                            

                                <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #d1edfc;width: 118px;height: 27px;border-radius: 30px" v-if="data === `New`">
                                    <!-- <p style="width: 9px;height: 9px;background: #41c4fd;margin-top: 5px;border-radius:50%"></p> -->
                                    <p style="font-size:12px;color:#41c4fd;"> New </p>
                                </div>
                            </template>

                    </a-table>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import XLSX from "xlsx";

const columns = [

	{
        title: 'ID',
        dataIndex: 'id',
        key:"id"
		// width: 200,
	},
	{
        title: 'Distribution Center',
        dataIndex: 'distributionCentreName',
        key:"distributionCentreName"
		//  width: 150,
	},
	{
        title: 'Quantity',
        dataIndex: 'quantity',
        key:"quantity"
		// width: 150,
	},
	{
		title: 'Action',
		key: 'action',
		dataIndex: 'action',
		scopedSlots: { customRender: 'action' }
	},
];



export default {
    name:"Waybills",
    // props: ['items'],
    data() {
        return {
            items: {},
            columns,
            tableData: [],
            tableLoading: false,
            pagination: {
                pageSize:20
            },
            params:{
                page: 1,
                perPage: 20,
                searchBy: {},
                sortBy: {},
                preorderCampaignId: 0,
            }
        };
    },
    computed:{
        ...mapGetters(['getOrder']),
        displayInvoiceId(){
            return this.items.id
        },
        
        showCampaignDate(){
            const today = moment();
            let startDate = moment(this.items.startDate).format("DD-MMM-YYYY")
            let endDate = moment(this.items.endDate).format("DD-MMM-YYYY")
            let numberOfDays = ""

            // console.log(" statusLabel | ", this.items.statusLabel)
            if(this.items.statusLabel === "Pending" ){
                numberOfDays = `${moment(this.items.startDate).diff(today.format(), 'days')} days to start campaign`
            }

            if(this.items.statusLabel === "Completed" ){
                numberOfDays = `${moment(today.format()).diff(this.items.endDate, 'days')} days after the end of campaign` 
            }

            if(this.items.statusLabel === "Live" ){
                numberOfDays = `${moment(this.items.endDate).diff(today.format(), 'days')} days at the end of campaign`
            }
            
            return {
                startDate: startDate,
                endDate: endDate,
                numberOfDays: numberOfDays
            }
        }
    },
    methods:{
        ...mapActions(['getWaybillOrderAsync','setPreviewInfo','getTopProducts']),
        addPreProduct(){
            this.$router.push('/new-pre-product').catch(()=>{});
        },
        redirectPreviousUrl(){
            this.$router.back()
        },
        showViewCampaign(){
              this.$router.push('/view-campaigns').catch(()=>{});
            },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        handleTableChange(pagination) {
            this.tableLoading = true
            // console.log("pagination in change | ", pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.params.page = pagination.current;
            this.params.perPage = pagination.pageSize;
            this.params.preorderCampaignId = this.items.id
            
            this.getPurchasedOrders(this.params);
        },
        getWaybillPrder(request_data){
              this.tableLoading = true;
              this.getWaybillOrderAsync(request_data).then(response => {
                this.tableLoading = false;
                // console.log('response in sales | ', response)
                if(response.status === 200){
                    const pagination = { ...this.pagination };
                    pagination.total = response.data.totalRecords;
                    let results = response.data.data;

                    this.tableData = results.map(product => ({
                        id:product.distributionCentreId,
                        key: product.distributionCentreId,
                        distributionCentreName:product.distributionCentreName,
                        quantity:product.quantityOrdered,
                        action: product
                    }))
                    this.pagination = pagination;
                }else{
                    this.tableLoading = false;
                    console.log('Error | ', response)
                }
                },
                error => {
                    this.tableLoading = false;
                    console.log('Error | ', error)
                })
        },
        randomString(length) {
            return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
        },
        showPurchaseOrder(){
            this.$router.push('/purchase-order').catch(()=>{});
        },
        showAggregateOrder(){
            this.$router.push('/aggregate-order').catch(()=>{});
        },
         exportExcell(){

            this.exportLoading = true
            const dataToExport = [
              [
                "Distribution Center",
                "Quantity"
              ],
            ];

            this.exportLoading = false;

            this.tableData.forEach((v) => {
              dataToExport.push([
                v.distributionCentreName,
                v.quantity
              ]);
            });

            let wb = XLSX.utils.book_new();
            let ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Distribution-Center-Order-Report-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.exportLoading = false;
            this.showSuccessAlert("Data Successfully Exported")
          },
        showWaybillModal(data){ 
            
            let topProductData = {
                page: -1,
                perPage: -1,
                searchBy: {
                    distributionCentreId:data.distributionCentreId
                },
                preorderCampaignId: this.items.id,
                sortBy: {},
            }
            this.getTopProducts(topProductData).then(response =>{
                // console.log("response distribution | ", response)
                if(response.status === 200){
                        let distributionData = response.data.data.map(product => ({
                            key:this.randomString(10),
                            id: product.id,
                            name: product.brandName ? product.brandName : "N/A",
                            category: product.categoryName ? product.categoryName : "N/A",
                            quantity: product.unitQuantity ? product.unitQuantity.toString() : '0',
                            unitPrice: product.purchasePrice ? product.purchasePrice.toString() : "0",
                            lineTotal: parseInt(product.unitQuantity) * parseInt(product.purchasePrice)
                        
                        }))
                        
                        let previewData = { 
                                discount: '',
                                deliveryDate: "",
                                supplierName: "",
                                supplierId: "",
                                distributionCentreName: data.distributionCentreName,
                                distributionCentreId: data.distributionCentreId,
                                supplierAddress: '',
                                supplierCity: '',
                                supplierCountry: '',
                                destionation: '',
                                shipAddress: '',
                                shipCity: '',
                                shipCountry:'',
                                shippingMethod: '',
                                shippinTerm: '',
                                tableData: distributionData
                            }
                        // console.log("previewData | ", previewData)
                        this.setPreviewInfo(JSON.stringify(previewData));  
                        this.$router.push('/waybill-receipt').catch(()=>{});
                }else{
                    // console.log("Error | ", response)
                }
            }, error =>{
                console.log("Error | ", error)
            })
            
           
        },
        loadWaybillOrder(){
            this.params.preorderCampaignId = this.items.id
            this.getWaybillPrder(this.params);
        }
    },
    created(){
        // console.log(" items in created | ", this.items);
        if(this.getOrder){
            this.items = this.getOrder
        }
        if(this.loadWaybillOrder){
            this.loadWaybillOrder();
        }
    }
}
</script>

<style scoped>

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.img_size{
    max-width: 40px;
    max-height: 40px;
}

.productTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.productTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.productTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.productTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.fulfillmentTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.fulfillmentTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.fulfillmentTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.fulfillmentTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}



</style>